import { Injectable } from '@angular/core';
import { BusyService } from 'app/shared/busy.service';
import { HttpClient } from '@angular/common/http';
import { UserWithRoles, IdentityData } from './identity-data';
import { environment } from 'environments/environment';
import { AuthUser } from 'app/shared/auth.service';
import { DialogWrapperService } from 'app/shared/dialog-wrapper.service';
import { ToastrService } from 'ngx-toastr';
import { firstValueFrom } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class UserAccountsService {
  constructor(
    private busyService: BusyService,
    private http: HttpClient,
    private dialogWrapperService: DialogWrapperService,
    private toastr: ToastrService
  ) { }

  async getIdentityData() {
    const url = environment.apiRoot + 'api/userAccount/GetIdentityData';
    const data = await firstValueFrom(this.http.get<IdentityData>(url));
    return data;
  }

  /** Session data is a list of userId + ":" + millisecond timestamp */
  async getSessionData() {
    const url = environment.apiRoot + 'api/login/ListAllSessionIds';
    const data = await firstValueFrom(this.http.get<string[]>(url));
    return data;
  }

  async getAuthUsersWithRole(roleName: string) {
    const iddata = await this.getIdentityData();
    const users = iddata.Users.filter(x => x.Roles.includes(roleName));
    const authUsers = users.map(x => AuthUser.fromUserWithRole(x));
    return authUsers;
  }

  async saveUser(user: UserWithRoles) {
    const url = environment.apiRoot + 'api/userAccount/SaveUser';
    return this.busyService.wrapBusy(async () => {
      try {
        const uwr = await this.http.post<UserWithRoles>(url, user).toPromise();
        this.toastr.success(`Saved user ${uwr.User.UserName}`);
        return uwr;
      } catch(err) {
        const message = (err.error && err.error.Message) || err.message;
        await this.dialogWrapperService.showOkMessage('Save Error', message);
        return null;
      }
    });
  }
}
